"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchStyled = void 0;
const design_system_components_1 = require("@produits-internes-oss/design-system-components");
const constants_1 = require("../../theme/constants");
exports.SearchStyled = styled(design_system_components_1.InputSearch) `
&.octo.hard {
  @media (min-width: ${constants_1.sizes.tablet}) {
    width: 50%;
  }

  @media (max-width: ${constants_1.sizes.tablet}) {
    width: 100%;
  }
}
`;
//# sourceMappingURL=Search.styled.js.map